module.exports = __webpack_public_path__ + "img/icon2-4.68111467.svg";